import "./css/bootstrap.min.css";
import "./css/tooplate-infinite-loop.css";
import Login from "./app/Screens/public/Login";
import Public from "./app/Screens/public/index";
import { FadeLoader } from "react-spinners";
import React from "react";
import OfflineBanner from "./app/components/OfflineBanner";

import { useState, useEffect, Fragment } from "react";
// import { getFCMToken, onMessageListener } from "./firebase";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import VerifyPage from "./app/Screens/public/VerifyNumber";
// import { setupNotifications } from "./firebase";
import {
  toastNotification,
  sendNativeNotification,
} from "./notificationHelper";
import useVisibilityChange from "./useVisibilityChange";
import NotificationManager from "./app/components/notification";
import SocketNotifications from "./app/components/SocketNotifications";
import MyBookings from "./app/Screens/secure/MyBookings/bookings";
import ConfirmationPage from "./app/Screens/public/ConfirmEmail";
import ResetPassword from "./app/Screens/public/ResetPassword";
import ForgotPassword from "./app/Screens/public/ForgotPassword";
import CheckEmail from "./app/Screens/public/CheckEmail";
import PasswordUpdated from "./app/Screens/public/PasswordUpdated";
import UserDetails from "./app/Screens/secure/components/UserDetails";
import SearchBar from "./app/Screens/secure/components/SearchBr";
import CalendarTest from "./app/Screens/secure/CalendarTest";
import Members from "./app/Screens/secure/Members";
import PackageManagement from "./app/Screens/secure/PackageManagement";
import { AlertProvider } from "./app/context/AlertContext";
import { NotificationsProvider } from "./app/context/NotificationsContext";
import Settings from "./app/Screens/secure/Settings";
import Profile from "./app/Screens/secure/Profile";
import Appointments from "./app/Screens/secure/Appointments";

function App() {
  const [authenticated, setAuthenticated] = useState(false);

  const [loading, setLoading] = useState(true);
  const [notification, setNotification] = useState(null);
  const [message, setMessage] = useState(null);

  const [path, setPath] = useState("");
  const isForeground = useVisibilityChange();
  // useEffect(() => {
  //   console.log("isForeground:", isForeground);
  //   console.log("message:", message);

  //   if (isForeground && message) {
  //     console.log("Received message in foreground:", message);

  //     // When the app is in the foreground and a message is received
  //     setNotification({
  //       title: message.title,
  //       body: message.body,
  //     });
  //   } else if (!isForeground && message) {
  //     console.log("Received message in background:", message);

  //     // If the app is in the background and a message is received
  //     if (Notification.permission === "granted") {
  //       new Notification(message.title, {
  //         body: message.body,
  //       });
  //     }
  //   }
  // }, []);
  // useEffect(() => {
  //   Notification.requestPermission().then((permission) => {
  //     if (permission === "granted") {
  //       console.log("Notification permission granted.");
  //     } else {
  //       console.log("Notification permission denied.");
  //     }
  //   });
  // }, []);

  const loginVerification = () => {
    console.log("Login verification called");
    setAuthenticated(true);
    setPath("/");
    window.location.replace("/");
    console.log(authenticated);
  };

  const checkUser = () => {
    const token = localStorage.getItem("token");
    // setAuthenticated(true);
    // setLoading(false);
    // return;

    // Check if the token exists
    if (token) {
      setAuthenticated(true);
      setLoading(false);
    } else {
      setAuthenticated(false);
      setLoading(false);
    }
  };
  useEffect(() => {
    if (authenticated) {
      console.log("User is now authenticated:", authenticated);
    }
  }, [authenticated]);

  const handleLoginVerification = () => {
    console.log("Login verification triggered");
  };

  // Call checkUser on component mount or whenever necessary
  useEffect(() => {
    checkUser(); // Check the user's authentication status when the component mounts
  }, []);

  return (
    <AlertProvider>
      <div className="App">
        <OfflineBanner />
        {loading ? (
          <div className="spinner-loader">
            <FadeLoader />
          </div>
        ) : (
          <Router>
            {authenticated && <SocketNotifications />}
            <NotificationsProvider>
            <Routes>
              <Route
                path="/verify/:guid"
                element={<VerifyPage loginVerification={loginVerification} />}
              />
              <Route path="/confirmation" element={<ConfirmationPage />} />
              <Route path="/forgotpassword/:guid" element={<ResetPassword />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/check-email" element={<CheckEmail />} />
              <Route path="/password-updated" element={<PasswordUpdated />} />
              <Route
                path="/login"
                element={<Login loginVerification={loginVerification} />}
              />

              {!authenticated ? (
                // <Route
                //   path="/"
                //   element={<Public loginVerification={loginVerification} />}
                // />
                <Route
                  path="/"
                  element={<Login loginVerification={loginVerification} />}
                />
              ) : (
                // <Route
                //   path="/"
                //   element={<CalendarTest checkUser={checkUser} />}
                // />
                // <Route
                //   path="/"
                //   element={<CalendarTest checkUser={checkUser} />}
                // />
                <>
                  <Route path="/search_clients" element={<SearchBar />} />
                  <Route
                    path="/"
                    element={<CalendarTest checkUser={checkUser} />}
                  />
                  <Route path="/members" element={<Members />} />
                  <Route path="/packages" element={<PackageManagement />} />
                  <Route path="/user_details/:id" element={<UserDetails />} />
                  <Route path="/my-bookings" element={<MyBookings />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route
                    path="/settings/appointments"
                    element={<Appointments />}
                  />
                </>
              )}
            </Routes>
            </NotificationsProvider>
          </Router>
        )}
      </div>
    </AlertProvider>
  );
}

export default App;
